import axios from 'axios';


const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_LATENCY_LOC,
  headers: {}
});

axiosInstance.interceptors.request.use(
  async (request) => {
    let token = "";
    try {
      token = localStorage.getItem("token");
    } catch {
      token = "<Not Required>";
    }
    request.headers = { ...request.headers, Authorization: `Bearer ${token}` };
    return request;
  },
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'There is an error!'
    )
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 && window.location.pathname !== `${process.env.REACT_APP_EL_URL}/login` && error.config.url !== `${process.env.REACT_APP_API_URL}/aacl/api/v1/aacl/token/generate`) {
      window.location.href = `${process.env.REACT_APP_EL_URL}/login`;
      localStorage.removeItem('token');
    }
    return Promise.reject(
      (error.response && error.response.data) || 'Session Expired!'
    );
  }
);

export default axiosInstance;
